module.exports = __webpack_public_path__ + "static/media/footer-logo.573b7837.png";